// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-complete-item[data-v-2ee130d0]{transition:all .3s}.list-complete-enter[data-v-2ee130d0],.list-complete-leave-to[data-v-2ee130d0]{opacity:0;transform:translateY(1.875rem)}.list-complete-leave-active[data-v-2ee130d0]{left:0;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
